// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by Table.js which is called by home component.
*/


table {
  width: 98%;
  margin: 1% auto;
  border-collapse: collapse;
  text-align: left;
  table-layout: fixed;
  font-family: 'Poppins', sans-serif;
  font-size: 16px !important;
  background-color: #fff;
  border-radius: 16px !important;
  overflow: hidden;
}

.table-dashboard {
  width: 100% !important;
  margin: 1% !important; 
  max-height: 55vh;
  margin-left: -38% !important;
  text-align: left;
  table-layout: auto;
  font-family: 'Poppins', sans-serif;
  font-size: 16px !important;
  background-color: #ffffff;           
  border: 1px solid #ccc;                   /* Optional: to visualize the container */
  display: table;                             /* Necessary for scrollbars to work */
}

thead th {
  background-color: #0C3135;
  top: 0;
  color: white;
  padding: 8px 12px;
  border: 1px solid #ddd;
  font-size: 14px;
  position: sticky;
  text-align: center; 
  vertical-align: middle; 
  min-width: 120px;
  max-width: 225px;
  max-height: 55vh;
}

thead, tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
thead {
  width: calc(100% - 8px); /* Adjust for the scrollbar width */
}

tbody tr {
  border-bottom: 1px solid #ddd;
  transition: background-color 0.3s ease;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
}

tbody {
  display: block;
  max-height: 55vh; 
  overflow-y: auto; /* Enable vertical scroll */
  overflow-x: hidden;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

tbody tr:hover {
  background-color: #f1f1f1;
}


tbody::-webkit-scrollbar {
  width: 8px;
}

tbody::-webkit-scrollbar-track {
  background: #f2f2f2;
  border-radius: 8px;
} 

tbody::-webkit-scrollbar-thumb {
  background: #0C3135;
  border-radius: 8px;
}

tbody::-webkit-scrollbar-thumb:hover {
  background: #2a5a5a;
}

td {
  vertical-align: middle;
  line-height: 1.3;
  max-width: 125px;
  border: 1px solid #ddd;
  text-align: left !important;
  padding: 8px 12px;
  word-wrap: break-word;
}

td, th {
  padding: 8px 16px;  /* Increased padding */
}


.table-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 4px 8px;  /* Reduced padding to allow more space */
}

.name-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  width: 100%;
  height: 100%;
}

.deployment-name {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  line-height: 1.3;
}

.table-heading {
  margin: 0 auto; 
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  flex-grow: 1;
}

.sort-arrows {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
}

.arrow {
  cursor: pointer;
  font-size: 10px;
  line-height: 1;
  padding: 1px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.2s ease;
}

.arrow:hover {
  color: #ffffff;
}

.button-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 1px;
  border-radius: 7px;
  min-width: 8px;
  height: 32px;                
  flex-shrink: 0;
}

.chevron-icon {
  color: #0c3135;
  transition: color 0.3s ease;
  width: 16px;
  height: 16px;
}

.button-toggle:hover:not([disabled]) .chevron-icon {
  background-color: #0C3135;
  color: #ffffff;
  border-radius: 4px;
}

.button-toggle[disabled],
.button-disabled {
  cursor: not-allowed;
  opacity: 0.2;
  pointer-events: none;
}

.dragging {
  background-color: #f0f0f0;
  opacity: 0.8;
  cursor: move;
}

.draggable-header {
  -webkit-user-select: none;
          user-select: none;
}

.resizer {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 4px;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}

.resizer:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.status-message{
  font-size: 16px;
  font-weight: bolder;
  text-align: center !important;
  color: #0C3135;
}

.status-message-error{
  font-size: 16px;
  font-weight: bolder;
  text-align: center !important;
  color: red;
}

.multi-container {
  white-space: pre-line;
  line-height: 1.3;
}

.highlight {
  background-color: rgb(25, 82, 25);
  color: white;
  padding: 2px 4px;
  border-radius: 3px;
}

@media  (max-width: 321px) {
  .table-dashboard{
    width:98%;
    height:35vh;
  }
  .table-dashboard thead{
    width:98%;
    height:10vh;
  }
}

@media (min-width: 426px) and (max-width: 769px) {
  tbody{
    max-height: 40vh;
  }
}

@media (min-width: 1025px) and (max-width: 1441px) {
  .table-dashboard{
    max-height: 67vh;
  }
  tbody {
    display: block;
    max-height: 70vh !important;
  }
}


@media (min-width: 1441px) and (max-width: 1921px) {
  .table-dashboard {
    max-height: 57vh;
    display: table;
    width: 100% !important;
  }
  
  tbody {
    display: block;
    max-height: 50vh  !important; 
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
  }
  
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
}

@media (min-width: 1921px){
  .table-dashboard{
    max-height: 80vh;
  }
  tbody {
    display: block;
    max-height: 80vh !important;
    overflow-y: auto; /* Enable vertical scroll */
    overflow-x: hidden;
  }
  table{
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ServiceInventoryDashboard/Table.css"],"names":[],"mappings":"AAAA;;CAEC;;;AAGD;EACE,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB,oBAAoB,yCAAyC;EACnF,cAAc,8BAA8B,qCAAqC;AACnF;;AAEA;EACE,yBAAyB;EACzB,MAAM;EACN,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,uBAAuB,EAAE,mCAAmC;AAC9D;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB,EAAE,2BAA2B;EAC7C,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB,GAAG,sBAAsB;AAC5C;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB,GAAG,wCAAwC;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,2BAA2B;EAC7B;AACF;;;AAGA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,2BAA2B;IAC3B,gBAAgB,EAAE,2BAA2B;IAC7C,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/*\nThis style file is imported by Table.js which is called by home component.\n*/\n\n\ntable {\n  width: 98%;\n  margin: 1% auto;\n  border-collapse: collapse;\n  text-align: left;\n  table-layout: fixed;\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px !important;\n  background-color: #fff;\n  border-radius: 16px !important;\n  overflow: hidden;\n}\n\n.table-dashboard {\n  width: 100% !important;\n  margin: 1% !important; \n  max-height: 55vh;\n  margin-left: -38% !important;\n  text-align: left;\n  table-layout: auto;\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px !important;\n  background-color: #ffffff;           \n  border: 1px solid #ccc;                   /* Optional: to visualize the container */\n  display: table;                             /* Necessary for scrollbars to work */\n}\n\nthead th {\n  background-color: #0C3135;\n  top: 0;\n  color: white;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  font-size: 14px;\n  position: sticky;\n  text-align: center; \n  vertical-align: middle; \n  min-width: 120px;\n  max-width: 225px;\n  max-height: 55vh;\n}\n\nthead, tbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\nthead {\n  width: calc(100% - 8px); /* Adjust for the scrollbar width */\n}\n\ntbody tr {\n  border-bottom: 1px solid #ddd;\n  transition: background-color 0.3s ease;\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n}\n\ntbody {\n  display: block;\n  max-height: 55vh; \n  overflow-y: auto; /* Enable vertical scroll */\n  overflow-x: hidden;\n}\n\ntbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\ntbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n\ntbody::-webkit-scrollbar {\n  width: 8px;\n}\n\ntbody::-webkit-scrollbar-track {\n  background: #f2f2f2;\n  border-radius: 8px;\n} \n\ntbody::-webkit-scrollbar-thumb {\n  background: #0C3135;\n  border-radius: 8px;\n}\n\ntbody::-webkit-scrollbar-thumb:hover {\n  background: #2a5a5a;\n}\n\ntd {\n  vertical-align: middle;\n  line-height: 1.3;\n  max-width: 125px;\n  border: 1px solid #ddd;\n  text-align: left !important;\n  padding: 8px 12px;\n  word-wrap: break-word;\n}\n\ntd, th {\n  padding: 8px 16px;  /* Increased padding */\n}\n\n\n.table-header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  padding: 4px 8px;  /* Reduced padding to allow more space */\n}\n\n.name-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  width: 100%;\n  height: 100%;\n}\n\n.deployment-name {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  line-height: 1.3;\n}\n\n.table-heading {\n  margin: 0 auto; \n  font-size: 15px;\n  font-weight: 600;\n  text-align: center;\n  flex-grow: 1;\n}\n\n.sort-arrows {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1px;\n}\n\n.arrow {\n  cursor: pointer;\n  font-size: 10px;\n  line-height: 1;\n  padding: 1px;\n  color: rgba(255, 255, 255, 0.8);\n  transition: color 0.2s ease;\n}\n\n.arrow:hover {\n  color: #ffffff;\n}\n\n.button-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 1px;\n  border-radius: 7px;\n  min-width: 8px;\n  height: 32px;                \n  flex-shrink: 0;\n}\n\n.chevron-icon {\n  color: #0c3135;\n  transition: color 0.3s ease;\n  width: 16px;\n  height: 16px;\n}\n\n.button-toggle:hover:not([disabled]) .chevron-icon {\n  background-color: #0C3135;\n  color: #ffffff;\n  border-radius: 4px;\n}\n\n.button-toggle[disabled],\n.button-disabled {\n  cursor: not-allowed;\n  opacity: 0.2;\n  pointer-events: none;\n}\n\n.dragging {\n  background-color: #f0f0f0;\n  opacity: 0.8;\n  cursor: move;\n}\n\n.draggable-header {\n  user-select: none;\n}\n\n.resizer {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 4px;\n  cursor: col-resize;\n  user-select: none;\n  touch-action: none;\n}\n\n.resizer:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.status-message{\n  font-size: 16px;\n  font-weight: bolder;\n  text-align: center !important;\n  color: #0C3135;\n}\n\n.status-message-error{\n  font-size: 16px;\n  font-weight: bolder;\n  text-align: center !important;\n  color: red;\n}\n\n.multi-container {\n  white-space: pre-line;\n  line-height: 1.3;\n}\n\n.highlight {\n  background-color: rgb(25, 82, 25);\n  color: white;\n  padding: 2px 4px;\n  border-radius: 3px;\n}\n\n@media  (max-width: 321px) {\n  .table-dashboard{\n    width:98%;\n    height:35vh;\n  }\n  .table-dashboard thead{\n    width:98%;\n    height:10vh;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n  tbody{\n    max-height: 40vh;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1441px) {\n  .table-dashboard{\n    max-height: 67vh;\n  }\n  tbody {\n    display: block;\n    max-height: 70vh !important;\n  }\n}\n\n\n@media (min-width: 1441px) and (max-width: 1921px) {\n  .table-dashboard {\n    max-height: 57vh;\n    display: table;\n    width: 100% !important;\n  }\n  \n  tbody {\n    display: block;\n    max-height: 50vh  !important; \n    overflow-y: auto;\n    overflow-x: hidden;\n    width: 100%;\n  }\n  \n  thead {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  }\n  \n  tbody tr {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  }\n}\n\n@media (min-width: 1921px){\n  .table-dashboard{\n    max-height: 80vh;\n  }\n  tbody {\n    display: block;\n    max-height: 80vh !important;\n    overflow-y: auto; /* Enable vertical scroll */\n    overflow-x: hidden;\n  }\n  table{\n    font-size: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
